import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpHeaders } from '@angular/common/http/src/headers';
import { environment } from '../../environments/environment';
import { CreateLogin } from '../models/create-login';
import { LoginReq, Mhsrcuser } from '../models/user';

@Injectable()
export class UserService {
  roleNone = '0';
  roleStudent = '1';
  roleAdmin = '2';
  roleInstructor = '3';
  roleSuper = '4';

  constructor(private _http: Http) { }

  _userUrl = `${environment.apiRootURL}/user`;

  sendCreateLogin(createLogin: CreateLogin) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');

    console.log('Http POST createLogin');
    const response = this._http.post(`${this._userUrl}/createLogin`,
      createLogin, options).map(response => response.json());
    return response;
  }

  updateLoginByEmail(email: string, updateUser: CreateLogin) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');

    console.log('Http POST updateuser');
    const response = this._http.post(`${this._userUrl}/updateuser/${email}`,
        updateUser, options).map(response => response.json());
    return response;
  }

  updateLoginById(updateUser: CreateLogin) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');

    console.log('Http POST updateuser');
    const response = this._http.post(`${this._userUrl}/updateuserbyid`,
        updateUser, options).map(response => response.json());
    return response;
  }

  UpdatePwdByEmail(email: string, pwd: string) {
    console.log('Http GET UpdatePwdByEmail');
    return this._http.get(`${this._userUrl}/UpdatePwdByEmail/${email}/${pwd}`).map(response => response.json());
  }

  GetUserByEmail(email: string) {
    console.log('Http GET GetuserByEmail');
    return this._http.get(`${this._userUrl}/GetUserByEmail/${email}`).map(response => response.json());
  }

  GetAdminUsers() {
    console.log('Http GET GetAdminUsers');
    return this._http.get(`${this._userUrl}/GetAdminUsers`).map(response => response.json());
  }

  GetUserByOTPC(OneTimePassCode: string) {
    console.log('Http GET getUserByOTPC');
    return this._http.get(`${this._userUrl}/GetUserByOTPC/${OneTimePassCode}`).map(response => response.json());
  }

  login(userLogin: LoginReq) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');

    console.log('Http POST login');
    const response = this._http.post(`${this._userUrl}/login`,
        userLogin, options).map(response => response.json());
        return response;
  }

  getVerification(email: string) {
    console.log('HTTP GET getVerification');
    // return this._http.get(`${this._userUrl}/getVerification/${email}`);
    return this._http.get(`${this._userUrl}/getVerification/${email}`).map(response => response.json());
  }

  // save a verification code of "null" (that is, a string that says "null") to set it to null
  saveVerification(email: string, verificationCode: string) {
    console.log('HTTP GET saveVerification');
    return this._http.get(`${this._userUrl}/saveVerification/${email}/${verificationCode}`).map(response => response.json());
  }

  updateSelectedAdmin(admin: Mhsrcuser) {
    return this._http.get(`${this._userUrl}/UpdatePwdByEmail/${admin.email}/${admin.password}`).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts